import { useState } from 'react';
import PropTypes from 'prop-types';
import { classNames } from 'uikit/utils';
import './Tooltip.scss';

export const Tooltip = ({ text, children, show, wide, className, ...rest }) => {
  const [isHovered, setIsHovered] = useState(false);
  const isVisible = typeof show === 'boolean' ? show : isHovered;

  return (
    <div
      className={classNames({ 'uikit-tooltip-wrapper': true, [className]: !!className })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...rest}
    >
      {children}
      {isVisible && text && (
        <div className={classNames({ 'uikit-tooltip': true, 'uikit-tooltip-wide': !!wide })}>{text}</div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  text: PropTypes.node,
  children: PropTypes.node,
  show: PropTypes.bool,
  wide: PropTypes.bool,
  className: PropTypes.string
};

export default Tooltip;
